import PageProductDetail from '~/themes/base/components/product/PageProductDetail/PageProductDetail.js'

const CERTIFICATION_PARAMETER_ENTITY_ID = '5e46c5b90f4e7700177c4741'
const MANUFACTURER_PARAMETER_ENTITY_ID = '5e46c5b90f4e7700177c473d'

export default {
  mixins: [PageProductDetail],
  data() {
    return {
      tabActive: 'description',
    }
  },
  mounted() {
    const tabNameFromUrl = this.$route.hash.replace(/^#/, '')
    if (tabNameFromUrl !== '') {
      if (this.tabsEnabled.includes(tabNameFromUrl)) {
        this.tabActive = tabNameFromUrl
      } else {
        this.$router.replace({ path: this.$route.path, query: this.$route.query })
      }
    }
  },
  computed: {
    certifications() {
      const certifications = this.product.content?.parameters
        ? this.product.content.parameters.find(
            parameter => parameter.entityId && parameter.entityId === CERTIFICATION_PARAMETER_ENTITY_ID,
          )
        : null
      if (certifications && certifications.valueEntities) {
        certifications.valueEntities = certifications.valueEntities.filter(
          c => c.parameter_value_image && c.parameter_value_image.length > 0,
        )
      }
      if (certifications) {
        return certifications.valueEntities.sort((a, b) => {
          return b.weight - a.weight
        })
      }
      return certifications
    },
    productParameters() {
      const blacklistedParameters = [CERTIFICATION_PARAMETER_ENTITY_ID, MANUFACTURER_PARAMETER_ENTITY_ID]
      return this.product.content?.parameters?.filter(parameter => !blacklistedParameters.includes(parameter.entityId))
    },
    productIngredients() {
      return (
        this.product.content &&
        this.product.content.product_ingredients &&
        this.product.content.product_ingredients[this.$i18n.locale] &&
        this.product.content.product_ingredients[this.$i18n.locale].replace(/\n/g, '<br>')
      )
    },
    selectedVariantIndex() {
      return this.product.variants.findIndex(variant => variant.id === this.selectedVariant.id)
    },
    shortDescription() {
      let result
      if (this.product.description) {
        const descriptionInOneLine = this.product.description.replace(/(\r\n|\n|\r)/gm, '')
        const descriptionParagraphs = descriptionInOneLine.match(/(<p>.*?<\/p>)/g)
        if (descriptionParagraphs && descriptionParagraphs.length > 0) {
          descriptionParagraphs.forEach(paragraph => {
            if (!result && paragraph.indexOf(this.product.name) === -1) {
              result = paragraph.replace(/<[^>]*>?/gm, '')
            }
          })
        }
      }
      return result
    },
  },
  methods: {
    scrollToTab(tab) {
      if (this.tabActive !== tab) {
        this.selectTab(tab)
      }
      this.$nextTick(() => {
        this.$scrollTo(`#${tab}`)
      })
    },
    selectTab(tab) {
      this.tabActive = tab
      this.$router.replace({ path: this.$route.path, query: this.$route.query, hash: tab })
    },
  },
}
